export default __webpack_public_path__ + "static/media/Location_Hamburg.db5c9177.svg";